










































































































import { appModule } from "@/store/modules/app";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KelasAutoComplete from "@/components/KelasAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    // UnitAutoComplete,
    KelasAutoComplete,
  },
})
export default class ModalListBooking extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() unit!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*No RM harus diisi"];
  msg = "";
  // unit = {};
  kelas = {};
  rm = null;
  catatan = null;
  get headers() {
    const head = [
      {
        text: "NO",
        value: "nomor",
        width: "5vh",
        align: "left",
      },
      {
        text: "RM",
        value: "pasien.cm_dash",
        width: "10vh",
        align: "left",
      },
      {
        text: "Identitas",
        value: "identitas",
        width: "25vh",
        align: "left",
      },
      {
        text: "Catatan Pemesanan",
        value: "catatan",
        align: "left",
      },
    ];
    return head;
  }
  get listBooking() {
    return storeBed.booking;
  }

  get dataPasien() {
    return storeBed.pasien;
  }

  dataPx(rm) {
    storeBed.actPasien(rm);
  }

  simpan() {
    // if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
    if (this.dataPasien["nama"]) {
      const dt = DataBed.postBooking(
        this.unit["id"],
        this.kelas["id"],
        this.catatan,
        this.user["pegawai_id"],
        this.rm,
        this.dataPasien["nama"]
      );
      dt.then((dt) => {
        if (dt["status"] != 1) {
          appModule.sendErrorAlert(dt["message"]);
        } else {
          this.catatan = "null";
          const param = {
            unitID: this.unit["id"],
            kelasID: this.kelas["id"],
          };
          appModule.NoticeDelay("Berhasil Menambahkan Pemesanan Kamar");
          storeBed.actBooking(param);
          this.catatan = null;
          this.rm = null;
          storeBed.actClearPasien();
          // this.close();
        }
      });
    } else {
      appModule.sendErrorAlert(
        "Pastikan RM Terisi dan Tekan Enter setelah input No RM"
      );
    }
    // }
  }

  hapus(val) {
    const dt = DataBed.deleteBooking(val.id, this.user["pegawai_id"]);
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        const param = {
          unitID: this.unit["id"],
          kelasID: this.kelas["id"],
        };
        appModule.NoticeDelay("Berhasil Hapus Pemesanan Kamar");
        storeBed.actBooking(param);
      }
    });
    // alert("hapus " + val);
  }

  setKelas(val) {
    this.kelas = val;
  }

  close() {
    storeBed.actClearPasien();
    storeBed.actClearBooking();
    this.rm = null;
    this.kelas = {};
    this.catatan = null;
    this.show = false;
  }

  message() {
    return this.msg;
  }

  get user() {
    return userModule.user;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  @Watch("kelas")
  watchKelas(val) {
    const param = {
      unitID: this.unit["id"],
      kelasID: val["id"],
    };
    storeBed.actBooking(param);
  }
}
